import { Action } from "@reduxjs/toolkit";
import { HomepageImageState } from "./types";
import { isType } from "typescript-fsa";
import { homepageImageActions } from "./actions";

const initialState: HomepageImageState = {
  image: null,
};

export function HomepageImageReducer(
  state = initialState,
  action: Action
): HomepageImageState {
  if (isType(action, homepageImageActions.fetchHomepageImage.done)) {
    // Only set image state if we have valid image data
    if (action.payload.result.image && action.payload.result.id) {
      return {
        ...state,
        image: {
          id: action.payload.result.id,
          image: action.payload.result.image,
        }
      };
    } else {
      // No image data available (e.g., {"cover":null,"message":"No cover image found."})
      return {
        ...state,
        image: null,
      };
    }
  }

  if (isType(action, homepageImageActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
